import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import ComboText from '../../../components/ComboText';
import { ESPECIALIDADITEMS } from '../../../utils/ConstantsMain';
import {
    TextField,
    IconButton,
    InputAdornment,
    Grid,
    Button,
    InputLabel,
    Select,
    FormControl,
    MenuItem,
    FormHelperText
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons'
import ButtonBase from '../../../components/Buttons/ButtonBase';
import './AddLawyerFirm.scss'

const useStyles = makeStyles({
    textField: {
        maxWidth: 256,
        margin: '0 24px 40px 0',
        height: 48,
        padding: 0,
    },
    linkStyle: {
        display: 'flex',
        justifyContent: 'center',
        margin: '0 24px 0 0'
    },
    buttonStyle: {
        minWidth: 280,
    },
    colorGrayIcon: {
        color: '#c1c1c1',
        padding: 0
    },
    cancel: {
        width: 160,
        height: 40,
        borderRadius: 20,
        backgroundColor: 'white',
        color: '#013957',
        border: '1px solid #013957',
        fontSize: 16,
        fontWeight: 'bold',
        textTransform: 'inherit',
    },
    inputLabelRoot: {
        transform: 'translate(14px, 16px) scale(1)',
    },
    inputLabelShrink: {
        transform: 'translate(14px, -6px) scale(0.75)',
        backgroundColor: '#fff',
        zIndex: 10,
    },
    formHelperTextRoot: {
        margin: '8px 14px',
        marginBottom: 0,
    },
    select: {
        minWidth: 256,
        '& .MuiInputLabel-marginDense': {
            transform: 'translate(14px, 16px) scale(1) !important',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            right: 22,
            bottom: 0,
        },
        '& .MuiInputLabel-shrink': {
            transform: 'translate(14px, -6px) scale(0.75) !important',
            zIndex: 10,
            right: 'unset',
            backgroundColor: '#fff',
            height: 'fit-content',
        },
    },
})

const AddLawyerFirmForm = (props) => {

    const {
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        touched,
        errors,
        isValid,
        isModal,
        handleClose,
        handleOpenFilter,
        handleShowAddLawyerFirm,
    } = props;

    const classes = useStyles()

    const [valuesPass, setValuesPass] = useState({
        password: '',
        showPassword: false,
    });

    const handleClickShowPassword = () => {
        setValuesPass({
            ...valuesPass,
            showPassword: !valuesPass.showPassword
        });
    };

    const onCancel = () => {
        if (!isModal) {
            handleOpenFilter()
        }
        handleShowAddLawyerFirm(false)
        if (handleClose) {
            handleClose()
        }
    }

    return (
        <form className={isModal ? 'addLawyerFirmFormModal' : 'addLawyerFirmForm'}>
            <Grid
                container
                direction="row"
            >
                <TextField
                    label="Nombre del despacho*"
                    id="lawFirmName"
                    type="text"
                    variant="outlined"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.lawFirmName ? values.lawFirmName : ''}
                    helperText={
                        touched.lawFirmName && errors.lawFirmName
                        ? errors.lawFirmName
                        : ''
                    }
                    error={touched.lawFirmName && errors.lawFirmName ? true : false}
                    className={classes.textField}
                />

                <FormControl
                    classes={{ root: classes.textField }}
                    variant="outlined"
                    error={touched.specialty && errors.specialty ? true : false}
                >
                    <InputLabel
                        htmlFor="select-multiple-checkbox"
                        classes={{
                            root: classes.inputLabelRoot,
                            shrink: classes.inputLabelShrink,
                        }}
                    >
                        {'Área de práctica*'}
                    </InputLabel>
                    <Select
                        id='specialty'
                        name='specialty'
                        value={values.specialty ? values.specialty : []}
                        onChange={handleChange}
                    >
                        <MenuItem value={''}>
                            Ninguno
                        </MenuItem>
                        {ESPECIALIDADITEMS && ESPECIALIDADITEMS.map((item, index) => (
                            <MenuItem key={index} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                    {touched.specialty && errors.specialty ? (
                        <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
                            {errors.specialty}
                        </FormHelperText>
                    ) : (
                        ''
                    )}
                </FormControl>

                <TextField
                    label="Número telefónico*"
                    id="phone"
                    type="text"
                    variant="outlined"
                    onBlur={handleBlur}
                    onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                    inputProps={{ minLength: 10, maxLength: 10 }}
                    onChange={handleChange}
                    value={values.phone}
                    helperText={touched.phone && errors.phone ? errors.phone : ''}
                    error={touched.phone && errors.phone ? true : false}
                    fullWidth
                    className={classes.textField}
                />

                <TextField
                    label="Cédula profesional*"
                    id="professionalLicense"
                    type="text"
                    variant="outlined"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.professionalLicense}
                    helperText={touched.professionalLicense && errors.professionalLicense ? errors.professionalLicense : ''}
                    error={touched.professionalLicense && errors.professionalLicense ? true : false}
                    fullWidth
                    className={classes.textField}
                />

                <TextField
                    label="Correo electrónico*"
                    id="email"
                    type="text"
                    variant="outlined"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email ? values.email : ''}
                    helperText={
                        touched.email && errors.email
                        ? errors.email
                        : ''
                    }
                    error={touched.email && errors.email ? true : false}
                    className={classes.textField}
                />

                <TextField
                    id="outlined-adornment-password"
                    variant="outlined"
                    type={valuesPass.showPassword ? 'text' : 'password'}
                    label="Contraseña*"
                    name='password'
                    className={classes.textField}
                    value={values.password ? values.password : ''}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    helperText={
                        touched.password && errors.password
                        ? errors.password
                        : ''
                    }
                    error={touched.password && errors.password ? true : false}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="Toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    classes={{
                                        root: classes.colorGrayIcon
                                    }}
                                >
                                    {valuesPass.showPassword ?
                                        <VisibilityOff /> :
                                        <Visibility />
                                    }
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
            </Grid>
 
            <Grid
                container
                direction="row"
            >
                <ButtonBase
                    type="submit"
                    onClick={handleSubmit}
                    variant="primary"
                    disabled={!isValid}
                    linkStyle={classes.linkStyle}
                    buttonStyle={classes.buttonStyle}
                >
                    Crear despacho
                </ButtonBase>

                <Button
                    type="button"
                    onClick={onCancel}
                    variant="outlined"
                    className={classes.cancel}
                >
                    Cancelar
                </Button>
            </Grid>
        </form>
    )
}

export default AddLawyerFirmForm;
